import { render, staticRenderFns } from "./livestockTrends.vue?vue&type=template&id=3f20ac9c&scoped=true&"
import script from "./livestockTrends.vue?vue&type=script&lang=js&"
export * from "./livestockTrends.vue?vue&type=script&lang=js&"
import style0 from "./livestockTrends.vue?vue&type=style&index=0&id=3f20ac9c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f20ac9c",
  null
  
)

export default component.exports